export enum ConfigElementComponentType {
    GROUP = 'group',
    DEFAULT = 'default',
    GLOBAL = 'global',
}
